import { uniqueId } from "lodash";
import { Select as InputSelect } from "../../screens/User/Users/User.style";
import Select from "react-select";
import { useCallback, useMemo, useState } from "react";
import { customStylesFilter } from "../../utils/helpers";

export const FilterDropdown = ({
  options,
  value,
  onChange,
  placeholder,
  where,
  searchable,
  name,
  disabled,
  id,
}: any) => {
  const [reactSelectOptions, setReactSelectOptions] = useState([]);

  const getOptionLabel = useCallback(
    (option: any) => {
      return option.label;
    },
    [reactSelectOptions]
  );

  const getOptionValue = useCallback(
    (option: any) => {
      return option.value;
    },
    [reactSelectOptions]
  );

  const handleOptionsChange = useCallback(
    (val: any) => {
      onChange(val);
    },
    [reactSelectOptions]
  );

  const getOpt = (opt: any, param: string) => {
    if (isObject(opt)) return opt[param];
    else return opt;
  };

  const isObject = (value: any): boolean => {
    return typeof value === "object" && value !== null;
  };

  useMemo(() => {
    if (searchable) {
      const transformedOptions = options.map((option: any) => ({
        label: getOpt(option, "label"),
        value: getOpt(option, "value"),
      }));

      setReactSelectOptions(transformedOptions);
    }
  }, [searchable, setReactSelectOptions]);

  return (
    <div id={id}>
      {searchable ? (
        <Select
          name={name}
          options={reactSelectOptions}
          placeholder={placeholder}
          // value={reactSelectValue}
          value={
            value
              ? reactSelectOptions.find((option: any) => option.value === value)
              : null
          }
          styles={customStylesFilter}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          onChange={handleOptionsChange}
          isDisabled={disabled}
        />
      ) : (
        <InputSelect
          disabled={disabled}
          value={value}
          onChange={onChange}
          where={where}
          data-testid="filter-select"
        >
          <option value="">{placeholder}</option>
          {options?.map((option: any) => (
            <option key={uniqueId()} value={option}>
              {option}
            </option>
          ))}
        </InputSelect>
      )}
    </div>
  );
};
